import { ExtendedPathKey } from "@noya-app/state-manager";

export function pathToString(extendedPath: ExtendedPathKey[]) {
  return extendedPath
    .map((key) =>
      typeof key === "object"
        ? `:${ellipsis(key.id.toString(), 8, "middle")}`
        : key
    )
    .map((key, index) =>
      index === 0 || (typeof key === "string" && key.startsWith(":"))
        ? key
        : `.${key}`
    )
    .join("");
}

export type EllipsisPosition = "start" | "middle" | "end";

export function ellipsis(
  str: string,
  maxLength: number,
  position: EllipsisPosition = "end"
) {
  if (str.length <= maxLength) return str;

  switch (position) {
    case "start":
      return `…${str.slice(str.length - maxLength)}`;
    case "middle": {
      const halfLength = Math.floor(maxLength / 2);
      return `${str.slice(0, halfLength)}…${str.slice(str.length - halfLength)}`;
    }
    case "end":
      return `${str.slice(0, maxLength)}…`;
  }
}

export function uploadFile() {
  return new Promise<File>((resolve, reject) => {
    const input = document.createElement("input");
    input.type = "file";
    input.onchange = () => {
      const file = input.files?.[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          const buffer = reader.result as ArrayBuffer;
          const blob = new File([buffer], file.name, { type: file.type });
          resolve(blob);
        };
        reader.onerror = () => {
          reject(new Error("Failed to read file"));
        };
        reader.readAsArrayBuffer(file);
      }
    };
    input.click();
  });
}
